import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesAccountDeletionMain } from './modules/ui/Main';

const AccountDeletionPage = (
  <SuspensePage>
    <PagesAccountDeletionMain />
  </SuspensePage>
);

export default AccountDeletionPage;
